import React, {Component} from 'react'
import {getResource} from '../../../../data/actions/resource'
import LocalStorage from '../../../../util/localStorage'
import Resources from '../../../../data/services/resources'
import {Field, FieldsManager} from '../../../../data/services/fields'
import moment from 'moment-timezone'
import {checkPerm, classNames, getProp} from '../../../../common/util/util-helpers'
import {numberWithCommas} from '../../../../util/util-formaters'
import {genericMoneyFormatter} from '../../../../common/util/util-vanilla'
import {
    ChevronDownIcon as ChevronDownSolidIcon,
    ChevronUpIcon,
    DocumentIcon,
    Squares2X2Icon
} from '@heroicons/react/20/solid'
import AccountReportDialog from '../../dialogs/account-report-dialog'
import {getSecondResource} from '../../../../data/actions/secondResource'
import Tippy from '@tippyjs/react'
import DocumentArrowDownIcon from '@heroicons/react/20/solid/DocumentArrowDownIcon'
import {DEFAULT_DATABASE_DATETIME_FORMAT, READ_PERM} from '../../../../util/util-constants'
import {download} from '../../../../data/actions/download'
import {currentDate} from '../../../../common/util/util-dates'
import {
    ArrowPathIcon,
    Bars4Icon,
    CurrencyDollarIcon,
    DocumentDuplicateIcon,
    MinusCircleIcon,
    XCircleIcon
} from '@heroicons/react/24/outline'
import PlusIcon from '@heroicons/react/20/solid/PlusIcon'
import PayDateFilter from "../../carrier-pay/carrier-pay-date-filter";
import FunnelIcon from "@heroicons/react/20/solid/FunnelIcon";
import InfoParagraph from "../../../../common/components/info-paragraph";
import FieldDate from "../../../../common/components/fields/field-date";
import {fieldsToHtml, getFieldLabelClass} from "../../../../common/util/util-fields";
import ModalDefault from "../../../../common/components/modal/modal-default";
import {LoaderSmall} from "../../../../common/components/loader";
import Card from "../../../../common/components/card";
import PageHeader from "../../../../common/components/layout/layout-components/page/page-header";
import EntryList from "./entry-list";
import ComparisonList from "./comparison-list";

const MAIN_ACCOUNT_TYPE_EXPENSE = 1
const MAIN_ACCOUNT_TYPE_INCOME = 2

export default class IncomeStatementTab extends Component {

    constructor(props) {
        super(props)
        this.state = {
            queryFilterFields: this.getQueryFilterFields(),
            selectedItem: null,
            accountDetailsDialog: false,
            comparisonDataView: false,
            comparisonDates: [],
            columnsInData: 2, // Split View
            zeroValuesShown: true,
            datesFilterDialogOpen: false,
            expandedAllCount: 0,
            collapsedAllCount: 0,
            columnStartDate: null,
            columnEndDate: null
        }
    }

    /** Lifecycle
     ================================================================= */
    componentDidMount = () => {
        this.fetchData()
    }

    /** Data Events
     ================================================================= */
    fetchData = () => {
        this.props.dispatch(getResource({
            user: LocalStorage.get('user'),
            resource: Resources.AccountingIncomeStatement,
            query: Object.assign({}, this.getQuery(), this.props.consolidated && {Consolidated: 1})
        }))
    }

    downloadExcel = () => {
        this.props.dispatch(download({
            user: LocalStorage.get('user'),
            resource: Resources.AccountingIncomeStatement,
            query: Object.assign({
                format: 'EXCEL',
                name: 'accounting_income_statement' + currentDate() + '.xlsx'
            }, this.getQuery())
        }))
    }

    downloadPdf = () => {
        this.props.dispatch(download({
            user: LocalStorage.get('user'),
            resource: Resources.AccountingIncomeStatement,
            query: Object.assign({
                format: 'PDF',
                name: 'accounting_income_statement' + currentDate() + '.pdf'
            }, this.getQuery())
        }))
    }

    downloadExcelReports = (query) => {
        this.props.dispatch(download({
            user: LocalStorage.get('user'),
            resource: Resources.AccountingAccountReport,
            query: Object.assign({
                format: 'EXCEL',
                name: 'income_statement_' + currentDate() + '.xlsx'
            }, query)
        }))
    }


    /** UI Events
     ================================================================= */
    handleInputChange = (name, value) => {
        this.setState({queryFilterFields: FieldsManager.updateField(this.state.queryFilterFields, name, value)}, this.fetchData)
    }

    handleComparisonDatesInputChange = (name, value, index) => {
        let fields = this.state.comparisonDates
        fields[index][name].value = value
        this.setState({comparisonDates: fields})
    }

    handleToggleCompareDatesModal = () => {
        if (this.state.comparisonDates.length > 0) {
            this.setState({
                comparisonDates: [],
                comparisonDataView: false
            }, this.fetchData)
        } else {
            this.setState({
                comparisonDates: [this.getQueryFilterFields()],
                comparisonDataModal: true
            })
        }
    }

    handleToggleAccountDetails = (selectedItem, column) => {
        let columnStartDate = null;
        let columnEndDate = null;

        if (column) {
            columnStartDate = this.state.comparisonDates[column]?.StartDate?.value;
            columnEndDate = this.state.comparisonDates[column]?.EndDate?.value;
        }

        this.setState({
            selectedItem: selectedItem,
            accountDetailsDialog: !this.state.accountDetailsDialog,
            columnStartDate: columnStartDate,
            columnEndDate: columnEndDate,
        })
    }

    handleToggleFilterDialog = () => {
        this.setState({
            datesFilterDialogOpen: !this.state.datesFilterDialogOpen
        })
    }

    /** Helpers
     ================================================================= */
    getQuery = () => {
        const StartDate = this.state.comparisonDates.map(it => {
            return it.StartDate.value.split(' ')[0]
        })
        const EndDate = this.state.comparisonDates.map(it => {
            return it.EndDate.value.split(' ')[0]
        })

        return this.state.comparisonDates.length > 0 ?
            {StartDate: StartDate, EndDate: EndDate} :
            FieldsManager.getFieldKeyValues(this.state.queryFilterFields)
    }

    getQueryFilterFields = () => {
        return {
            StartDate: new Field('StartDate', moment().startOf('year').format(DEFAULT_DATABASE_DATETIME_FORMAT), ['date'], false, 'date', {
                addContainerClass: 'col-span-4'
            }),
            EndDate: new Field('EndDate', moment().format(DEFAULT_DATABASE_DATETIME_FORMAT), ['date'], false, 'date', {
                addContainerClass: 'col-span-4'
            })
        }
    }

    groupBy = (arr, property) => {
        return arr?.reduce(function (memo, x) {
            if (!memo[x[property]]) {
                memo[x[property]] = []
            }
            memo[x[property]].push(x)
            return memo
        }, {})
    }

    getIncomes = (data) => {
        const Accounts = getProp(this.props, 'resource.data.Accounts', data ?? {})
        const groupedItems = this.groupBy(Object.values(Accounts), 'MainAccountTypeID')
        const res = Object.keys(groupedItems).length ? this.groupBy(groupedItems[MAIN_ACCOUNT_TYPE_INCOME], 'AccountType') : {}
        return res ? res : {}
    }

    getExpenses = (data) => {
        const Accounts = getProp(this.props, 'resource.data.Accounts', data ?? {})
        const groupedItems = this.groupBy(Object.values(Accounts), 'MainAccountTypeID')
        const res = Object.keys(groupedItems).length ? this.groupBy(groupedItems[MAIN_ACCOUNT_TYPE_EXPENSE], 'AccountType') : {}
        return res ? res : {}
    }

    handleExpandAllClick = () => {
        this.setState({
            expandedAllCount: this.state.expandedAllCount + 1
        })
    }

    handleCollapseAllClick = () => {
        this.setState({
            collapsedAllCount: this.state.collapsedAllCount + 1
        })
    }

    /** Render
     ================================================================= */
    render() {
        const {translate} = this.props

        const fieldsHtml = fieldsToHtml(Object.values(Object.assign({}, this.state.queryFilterFields)), translate, this.handleInputChange)

        const incomes = this.getIncomes()
        const expenses = this.getExpenses()

        const Income = getProp(this.props, 'resource.data.Income', 0)
        const Expense = getProp(this.props, 'resource.data.Expense', 0)
        const NetIncome = getProp(this.props, 'resource.data.NetIncome', 0)

        const comparisonData = Array.isArray(getProp(this.props, 'resource.data', [])) && getProp(this.props, 'resource.data', []);
        let comparisonDataByColumns;
        let comparisonColumns = {};
        let numberOfColumns = 2;
        if (comparisonData) {
            comparisonDataByColumns = comparisonData.reduce((memo, column, index) => {
                if (!comparisonColumns[index]) {
                    comparisonColumns[index] = {Total: 0};
                }

                Object.keys(column.Accounts).forEach(accountID => {
                    if (!memo[accountID]) {
                        memo[accountID] = {}
                    }

                    memo[accountID][index] = column.Accounts[accountID];

                    comparisonColumns[index].Total += column.Accounts[accountID].Value;
                })
                return memo;
            }, {});

            numberOfColumns = Object.keys(comparisonColumns).length + 1;
        }

        return (
            <Card>
                <div className="mb-5">
                    <PageHeader
                        title={translate('page.heading.IncomeStatement')}
                    >
                        <div className="flex items-center space-x-2">
                            <Tippy content={translate('btn.expand_all')}>
                                <button
                                    className="btn-icon relative size-9"
                                    onClick={this.handleExpandAllClick}
                                >
                                    <ChevronUpIcon className="w-4 h-4 absolute top-1 left-1/2 -translate-x-1/2"/>
                                    <ChevronDownSolidIcon
                                        className="w-4 h-4 absolute bottom-1 left-1/2 -translate-x-1/2"/>
                                </button>
                            </Tippy>

                            <Tippy content={translate('btn.collapse_all')}>
                                <button
                                    className="btn-icon relative size-9"
                                    onClick={this.handleCollapseAllClick}
                                >
                                    <ChevronDownSolidIcon className="w-4 h-4 absolute top-1 left-1/2 -translate-x-1/2"/>
                                    <ChevronUpIcon className="w-4 h-4 absolute bottom-1 left-1/2 -translate-x-1/2"/>
                                </button>
                            </Tippy>

                            <Tippy
                                content={translate(`text.${this.state.zeroValuesShown ? 'HideZeroValues' : 'ShowZeroValues'}`)}>
                                <button
                                    className={classNames('btn-icon relative', !this.state.zeroValuesShown ? 'text-primary' : undefined)}
                                    onClick={() => this.setState({zeroValuesShown: !this.state.zeroValuesShown})}
                                >
                                    <CurrencyDollarIcon className="w-5 h-5"/>

                                    {!this.state.zeroValuesShown && (
                                        <span
                                            className="top-1.5 left-1.5 animate-ping absolute inline-flex h-6 w-6 rounded-md bg-primary opacity-75"
                                        ></span>
                                    )}
                                </button>
                            </Tippy>
                            <Tippy content={translate('text.download_excel')}>
                                <button
                                    className="btn-icon"
                                    onClick={this.downloadExcel}
                                >
                                    <DocumentArrowDownIcon className="w-5 h-5"/>
                                </button>
                            </Tippy>
                            <Tippy content={translate('text.download_pdf')}>
                                <button
                                    className="btn-icon"
                                    onClick={this.downloadPdf}
                                >
                                    <DocumentIcon className="w-5 h-5"/>
                                </button>
                            </Tippy>
                            <Tippy
                                content={translate(`text.${this.state.comparisonDates.length > 0 ? 'ClearFilter' : 'CompareDates'}`)}>
                                <button
                                    className="btn-icon"
                                    onClick={this.handleToggleCompareDatesModal}
                                >
                                    <DocumentDuplicateIcon
                                        className={`w-5 h-5 ${this.state.comparisonDates.length > 0 ? 'text-red-600' : ''}`}/>
                                </button>
                            </Tippy>

                            {!this.state.comparisonDataView && (
                                <button
                                    className="btn-icon"
                                    title={translate('text.Filters')}
                                    onClick={this.handleToggleFilterDialog}
                                >
                                    <FunnelIcon className="w-5 h-5"/>
                                </button>
                            )}

                            <button
                                className={
                                    classNames(
                                        "btn btn-header z-10 ml-8"
                                    )
                                }
                                onClick={this.fetchData}
                            >
                                <ArrowPathIcon className={
                                    classNames(
                                        "w-5 h-5",
                                        this.props.resource?.isLoading || this.props.secondResource?.isLoading ? "animate-spin" : undefined
                                    )
                                }/>
                            </button>
                        </div>
                    </PageHeader>
                </div>

                {!!this.state.comparisonDataView && (
                    <div>
                        <div className={`grid gap-5 grid-cols-${this.state.comparisonDates.length + 1}`}>
                            <div/>
                            {this.state.comparisonDates.map((it, index) => (
                                <div
                                    className="px-3 py-3.5 text-right text-sm font-semibold text-tm-gray-500 -mr-6">
                                    <div className="flex justify-end">
                                        <div>{moment(it.StartDate.value).format('MMMM Do YYYY')} - {moment(it.EndDate.value).format('MMMM Do YYYY')}</div>
                                        <Tippy content={
                                            <span>{translate('text.RemoveDateFromComparison')}</span>}>
                                            <MinusCircleIcon
                                                onClick={() => {
                                                    let comparisonDates = this.state.comparisonDates
                                                    comparisonDates.splice(index, 1)
                                                    this.setState({
                                                        comparisonDates: comparisonDates,
                                                        comparisonDataView: comparisonDates.length !== 0 // Changing view if last removed
                                                    }, () => {
                                                        this.fetchData()
                                                    })
                                                }}
                                                className={'-rotate-45 size-5 text-red-600 ml-3 cursor-pointer'}/>
                                        </Tippy>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className={``}>
                            <ComparisonList
                                data={comparisonDataByColumns}
                                columns={comparisonColumns}
                                handleToggleAccountDetails={this.handleToggleAccountDetails}
                                zeroValuesShown={this.state.zeroValuesShown}
                                expandedAllCount={this.state.expandedAllCount}
                                collapsedAllCount={this.state.collapsedAllCount}
                            />
                        </div>

                        {Array.isArray(getProp(this.props, 'resource.data', [])) && (
                            <>
                                <hr className="my-2 text-right"/>
                                <div
                                    className={`grid gap-5 pl-16 font-bold text-lg`}
                                    style={{gridTemplateColumns: `repeat(${numberOfColumns}, 1fr)`}}
                                >
                                    <div>Total Income</div>
                                    {getProp(this.props, 'resource.data', []).map((it, index) => (
                                        <div key={index} className="text-right">{genericMoneyFormatter(it.Income)}</div>
                                    ))}
                                </div>
                                <hr className="my-2"/>
                                <div
                                    className={`grid gap-5 pl-16 font-bold text-lg`}
                                    style={{gridTemplateColumns: `repeat(${numberOfColumns}, 1fr)`}}
                                >
                                    <div>Total Expense</div>
                                    {getProp(this.props, 'resource.data', []).map((it, index) => (
                                        <div key={index}
                                             className="text-right">{genericMoneyFormatter(it.Expense)}</div>
                                    ))}
                                </div>
                                <hr className="my-2"/>
                                <div
                                    className={`grid gap-5 pl-16 font-bold text-lg`}
                                    style={{gridTemplateColumns: `repeat(${numberOfColumns}, 1fr)`}}
                                >
                                    <div>Net Income</div>
                                    {getProp(this.props, 'resource.data', []).map((it, index) => (
                                        <div key={index}
                                             className="text-right">{genericMoneyFormatter(it.NetIncome)}</div>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                )}

                {!this.state.comparisonDataView && (
                    <>
                        <div className="row mb-4">
                            <div className="col p-5 grid grid-cols-12 gap-4">
                                {fieldsHtml}
                            </div>

                            <div className="col flex justify-end items-end">
                                <div className="flex justify-end items-end">
                                    <Tippy content={translate('text.StackedView')}>
                                        <button
                                            onClick={() => this.setState({columnsInData: 1})}
                                            className={`${this.state.columnsInData === 1 && 'bg-tm-gray-200-500'} h-full relative inline-flex items-center px-4 py-2 rounded-l-md border border-tm-gray-300 text-sm font-medium text-gray-700 focus:z-10 focus:outline-hidden focus:ring-1 text-tm-gray-700`}
                                        >
                                            <Bars4Icon
                                                className={`${this.state.columnsInData === 1 && 'text-primary'} w-5 h-5`}
                                                aria-hidden="true"/>
                                        </button>
                                    </Tippy>
                                    <Tippy content={translate('text.SplitView')}>
                                        <button
                                            onClick={() => this.setState({columnsInData: 2})}
                                            className={`${this.state.columnsInData === 2 && 'bg-tm-gray-200-500'} h-full -ml-px relative inline-flex items-center px-4 py-2 rounded-r-md border border-tm-gray-300 text-sm font-medium text-gray-700 focus:z-10 focus:outline-hidden focus:ring-1 text-tm-gray-700`}
                                        >
                                            <Squares2X2Icon
                                                className={`${this.state.columnsInData === 2 && 'text-primary'} w-5 h-5`}
                                                aria-hidden="true"/>
                                        </button>
                                    </Tippy>
                                </div>
                            </div>
                        </div>

                        <div className="text-center">
                            <h1 className={'font-bold'}>{translate('tab.income_statement')}</h1>
                            <h2>From {moment(this.state.queryFilterFields.StartDate.value, 'YYYY-MM-DD 00:00:00').format('MMMM Do YYYY')} to {moment(this.state.queryFilterFields.EndDate.value, 'YYYY-MM-DD 00:00:00').format('MMMM Do YYYY')}</h2>
                        </div>

                        <div>
                            <div className={
                                classNames(
                                    `border-t border-tm-gray-200 grid`,
                                    this.state.columnsInData === 2 ? "grid-cols-2 divide-x divide-tm-gray-200" : "grid-cols-1"
                                )
                            }>
                                <EntryList
                                    name="Revenue"
                                    entries={incomes}
                                    handleToggleAccountDetails={this.handleToggleAccountDetails}
                                    zeroValuesShown={this.state.zeroValuesShown}
                                    expandedAllCount={this.state.expandedAllCount}
                                    collapsedAllCount={this.state.collapsedAllCount}
                                />

                                <EntryList
                                    name="Expenses"
                                    entries={expenses}
                                    handleToggleAccountDetails={this.handleToggleAccountDetails}
                                    zeroValuesShown={this.state.zeroValuesShown}
                                    expandedAllCount={this.state.expandedAllCount}
                                    collapsedAllCount={this.state.collapsedAllCount}
                                />
                            </div>

                            <div className={`divide-x divide-tm-gray-200 grid grid-cols-2`}>
                                <div className="flex items-center justify-between pl-5 font-bold text-lg pb-4 px-4">
                                    <div>Total Income</div>
                                    <div>{genericMoneyFormatter(Income)}</div>
                                </div>

                                <div className="flex items-center justify-between pl-5 font-bold text-lg pb-4 px-4">
                                    <div>Total Expense</div>
                                    <div>{genericMoneyFormatter(Expense)}</div>
                                </div>
                            </div>


                            <h2 className="text-xl text-center py-4 border-t border-tm-gray-200"><strong>Net
                                income</strong>: {numberWithCommas(NetIncome)}</h2>
                        </div>
                    </>
                )}


                {this.props.resource.isLoading && (
                    <LoaderSmall/>
                )}

                <ModalDefault
                    show={!!this.state.comparisonDataModal}
                    widthClass={'max-w-xl'}
                    title={translate('text.SelectDatesForComparison')}

                    onButtonClick={() => {
                        // Removing duplicates
                        const dates = this.state.comparisonDates.filter((value, index, self) =>
                                index === self.findIndex((t) => (
                                    (t.StartDate.value + t.StartDate.value) === (value.StartDate.value + value.StartDate.value)
                                ))
                        )
                        this.setState({
                            comparisonDates: dates,
                            comparisonDataView: true,
                            comparisonDataModal: false
                        }, this.fetchData)
                    }}
                    buttonLabel={translate('btn.save')}

                    closeButtonLabel={translate('btn.Cancel')}
                    onClose={() => this.setState({comparisonDataModal: false, comparisonDates: []})}
                >
                    <div className="p-5">
                        {this.state.comparisonDates.map((item, i) => (
                            <div className={'mb-5'} key={i}>
                                <span className={classNames(getFieldLabelClass(), 'flex justify-between items-center')}>
                                    <span>{translate('field.Date')} {i + 1}</span>
                                    {i !== 0 && (
                                        <XCircleIcon
                                            onClick={() => {
                                                let comparisonDates = this.state.comparisonDates
                                                comparisonDates.splice(i, 1)
                                                this.setState({comparisonDates})
                                            }}
                                            className={'h-4 w-4 cursor-pointer'}/>
                                    )}
                                </span>
                                <div className="grid grid-cols-2 gap-3">
                                    <FieldDate
                                        addClass={'form-control'}
                                        onChange={(name, value) => this.handleComparisonDatesInputChange(name, value, i)}
                                        showTimeSelect={false}
                                        {...item.StartDate}
                                    />
                                    <FieldDate
                                        addClass={'form-control'}
                                        onChange={(name, value) => this.handleComparisonDatesInputChange(name, value, i)}
                                        showTimeSelect={false}
                                        {...item.EndDate}
                                    />
                                </div>
                            </div>
                        ))}

                        {this.state.comparisonDates.length < 5 ?
                            <div className="flex justify-center items-center mt-5">
                                <Tippy
                                    content={translate('btn.AddAnotherDate')}
                                >
                                    <button
                                        className="mx-1 bg-tm-gray-100 p-2 rounded-full text-tm-gray-700 hover:bg-tm-gray-200 focus:outline-hidden focus:ring-2 ring-offset-inverse ring-link focus:ring-offset-2"
                                        onClick={() => {
                                            this.setState({
                                                comparisonDates: this.state.comparisonDates.concat(this.getQueryFilterFields())
                                            })
                                        }}
                                    >
                                        <PlusIcon className="h-4 w-4"/>
                                    </button>
                                </Tippy>
                            </div>
                            :
                            <InfoParagraph message={'Maximum comparison dates reached.'}/>
                        }
                    </div>
                </ModalDefault>

                <AccountReportDialog
                    AccountID={this.state.selectedItem?.AccountID}
                    AccountName={this.state.selectedItem?.AccountName}
                    StartDate={this.state.columnStartDate ? this.state.columnStartDate : this.state.queryFilterFields.StartDate?.value}
                    EndDate={this.state.columnEndDate ? this.state.columnEndDate : this.state.queryFilterFields.EndDate?.value}
                    onClose={this.handleToggleAccountDetails}
                    show={checkPerm(Resources.AccountingAccountReport, READ_PERM) && this.state.accountDetailsDialog}
                    translate={this.props.translate}
                    getTransactions={(query) => {
                        this.props.dispatch(getSecondResource({
                            user: LocalStorage.get('user'),
                            resource: Resources.AccountingAccountReport,
                            query: query
                        }))
                    }}
                    downloadExcelReports={(query) => this.downloadExcelReports(query)}
                    isLoading={getProp(this.props, 'secondResource.isLoading', false)}
                    transactions={getProp(this.props, 'secondResource.data', [])}
                    thirdResource={this.props.thirdResource}
                    dialogResource={this.props.dialogResource}
                    dispatch={this.props.dispatch}
                />

                <ModalDefault
                    show={!!this.state.datesFilterDialogOpen}
                    widthClass={'max-w-3xl'}
                    title={"Dates filter"}

                    closeButtonLabel={translate('btn.close')}
                    onClose={this.handleToggleFilterDialog}

                    translate={translate}
                >
                    <PayDateFilter
                        queryFields={this.state.queryFilterFields}
                        translate={translate}
                        updateQueryFields={(queryFieldsUpdate) => {
                            this.setState({
                                queryFilterFields: queryFieldsUpdate
                            }, () => {
                                this.fetchData()
                            })
                        }}
                        hasDateType={false}
                        isDateTypeClearable={false}
                        isClearDatesButtonVisible={false}
                        onQueryChange={this.handleInputChange}
                    />
                </ModalDefault>
            </Card>
        )
    }
}
